import { SortOptionValues } from '..'

export interface IItemTraitSet {
  mailboxIDs: number[] /* All convos only */
  projectIDs: number[] /* All tasks only */
  priorityIDs: number[]
  statusIDs: number[]
  statusType: string
  assigneeIDs: number[]
  assignedNotToYou: boolean
  jobAppointeeGroupingsString: string
  sort: string
  dueType: number
  includingTagIDs: number[]
  notIncludingTagIDs: number[]
  startDueDate: string
  endDueDate: string
  searchTerm: string
  onlyWatching: boolean
  createdWithinDays?: number
  lastUpdatedWithinDays?: number
  creatorIDs: number[] /* All tasks/project only */
  customerIDs: number[] /* All convos/mailbox only */
  isSpam: boolean /* All convos/mailbox only */
  [key: string]: any
}

export interface ICustomFilterItemTraitSet {
  id: number
  itemTraitSet: IItemTraitSet
}

export interface IItemFiltersPanelState {
  showFilterAssignees: boolean
  showFilterCustomers: boolean
  showFilterDue: boolean
  showFilterPriorities: boolean
  showFilterStatuses: boolean
  showFilterTags: boolean
  showFilterSpam: boolean
  showFilterWatching: boolean
  showFilterCreatedWithinDays: boolean
  showFilterLastUpdatedWithinDays: boolean
  showFilterSort: boolean
}

export const DefaultItemTraitSet: IItemTraitSet = {
  mailboxIDs: [], // All convos only
  projectIDs: [], // All tasks only
  priorityIDs: [],
  statusIDs: [],
  statusType: '',
  assigneeIDs: [],
  assignedNotToYou: false,
  jobAppointeeGroupingsString: '',
  sort: SortOptionValues.UPDATED_RECENT,
  dueType: null,
  includingTagIDs: [],
  notIncludingTagIDs: [],
  startDueDate: null,
  endDueDate: null,
  searchTerm: '',
  onlyWatching: false,
  createdWithinDays: null,
  lastUpdatedWithinDays: null,
  creatorIDs: [], // Tasks only
  customerIDs: [], // Convos only
  isSpam: false, // Convos only
}
